export enum BaremoType {
    car,
    pickup,
    all
}
